export const SUBMISSION_ERROR_CODE = {
    ACCOUNT_NOT_CONFIRMED: 'ACCOUNT_NOT_CONFIRMED',
    ACCOUNT_REGISTERED_THROUGH_THIRD_PARTY_IDP: 'ACCOUNT_REGISTERED_THROUGH_THIRD_PARTY_IDP',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    LIMIT_EXCEEDED_EXCEPTION: 'LIMIT_EXCEEDED_EXCEPTION',
    INVALID_CONFIRMATION_CODE: 'INVALID_CONFIRMATION_CODE',
    NOT_AUTHORIZED: 'NOT_AUTHORIZED'
}
